import { Col, Divider, Row } from 'antd';
import PrimaryButton, { SecondaryButton } from '../Button/Button';
import TabIndicator from '../TabIndicator/TabIndicator';
import './_form-wrapper.scss';

interface FormButton {
  loading?: boolean;
  active?: boolean;
  title: string;
  disabled?: boolean;
  onClick: () => any
}

interface Props {
  children: any;
  tabs?: Array<object>;
  activeTab?: number;
  secondaryButton: FormButton;
  secondSecondaryButton?: FormButton;
  primaryButton: FormButton;
  validationAlert?: React.ReactNode;
}

const FormWrapper: React.FC<Props> = ({
  children,
  tabs,
  activeTab,
  secondaryButton,
  secondSecondaryButton,
  primaryButton,
  validationAlert
}) => {
  return (
    <>
      {activeTab && tabs && <>
        <TabIndicator tabs={tabs} activeTab={activeTab} />
        <Divider className="form-divider-A" />
      </>}
      {validationAlert}
      <div className="form-wrapper">
        {children}
        <Divider className="form-divider-B" />
        <Row gutter={16} justify="end" align="middle">
          {secondaryButton?.active && (
            <Col>
              <SecondaryButton
                disabled={secondaryButton.disabled}
                loading={secondaryButton.loading}
                onClick={secondaryButton.onClick}
              >
                {secondaryButton.title}
              </SecondaryButton>
            </Col>
          )}
          {secondSecondaryButton && secondSecondaryButton?.active && (
            <Col>
              <SecondaryButton
                disabled={secondSecondaryButton.disabled}
                loading={secondSecondaryButton.loading}
                onClick={secondSecondaryButton.onClick}
              >
                {secondSecondaryButton.title}
              </SecondaryButton>
            </Col>
          )}
          {primaryButton?.active && (
            <Col>
              <PrimaryButton
                disabled={primaryButton.disabled}
                loading={primaryButton.loading}
                onClick={primaryButton.onClick}
              >
                {primaryButton.title}
              </PrimaryButton>
            </Col>
          )}
        </Row>
      </div>
    </>
  );
};

export default FormWrapper;
